import React, { useState } from "react";
import { FaExclamationCircle, FaCalendarAlt, FaLink, FaEdit, FaTrash } from "react-icons/fa";
import { PiMapPinAreaBold } from "react-icons/pi";
import { MdCategory } from "react-icons/md";
import { FaRegImage } from "react-icons/fa";
import { formatDate } from "../../utils/dateUtils.js";
import { getBackgroundColor, getLevelIcon } from "../../utils/priorityUtils.js";
import AlertImageModal from "../modals/Image/AlertImageModal.jsx";

function AlertCard({
	pauseScroll,
	alert,
	isAuthenticated = false,
	mode,
	onEdit,
	onDelete,
	editable = false,
	style,
	className,
}) {
	const [showModal, setShowModal] = useState(false);

	return (
		<>
			<div
				className={`relative w-full max-w-lg ${getBackgroundColor(
					alert.category_name,
					alert.priority
				)} p-6 rounded-lg shadow-lg border-2 overflow-scroll ${className}`}
				style={style}
			>
				{/* Azioni fisse */}
				{editable && (
					<div className="absolute top-2 right-2 flex space-x-2">
						<button
							id="edit"
							aria-label="Modifica"
							className="p-2 bg-yellow-500 text-white rounded-full hover:bg-yellow-600 shadow"
							onClick={() => onEdit(alert)}
							title="Modifica"
						>
							<FaEdit size={16} />
						</button>
						<button
							id="delete"
							aria-label="Elimina"
							className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600 shadow"
							onClick={() => onDelete(alert.id)}
							title="Elimina"
						>
							<FaTrash size={16} />
						</button>
					</div>
				)}

				{/* Titolo */}
				<h3 className="text-lg font-bold text-gray-800 mb-2 text-center flex items-center justify-center gap-2">
					<span className="text-5xl">{getLevelIcon(alert.priority)}</span>
					{alert.title}
				</h3>

				{/* Categoria */}
				<p className="text-lg  mb-2 flex items-center gap-2">
					<MdCategory className="text-orange-500" />
					<strong>{alert.category_name}</strong>
				</p>

				{/* Area */}
				{alert.area_name && (
					<p className="text-md text-gray-900 mb-2 flex items-center gap-2">
						<PiMapPinAreaBold className="text-blue-500" />
						Area: <span className="font-semibold">{alert.area_name}</span>
					</p>
				)}

				{/* Descrizione */}
				{alert.description && (
					<p className="text-md text-gray-900 mb-2 gap-2">
						<span className="flex items-center gap-2">
							<FaExclamationCircle className="text-orange-500" />
							Descrizione
						</span>
						<span className="ml-5 font-semibold">{alert.description}</span>
					</p>
				)}

				{/* Data di scadenza */}
				<p className="text-md text-gray-900 mt-4 flex items-center gap-2">
					<FaCalendarAlt className="text-green-500" />
					<span className="">
						Valido da: <span className="font-bold">{formatDate(alert.valid_date)}</span>
						<br />
						A: <span className="font-bold">{formatDate(alert.expire_date)}</span>
					</span>
				</p>

				{/* Link allerta */}
				{alert.alert_link && (
					<p className="text-md text-blue-900 mt-4 flex items-center gap-2">
						<FaLink className="text-blue-500" />
						<a
							href={alert.alert_link}
							target="_blank"
							rel="noopener noreferrer"
							className="hover:underline"
						>
							Leggi di più sull'allerta
						</a>
					</p>
				)}

				{/* Immagine allerta */}
				{isAuthenticated && (
					<p className="text-md text-blue-900 mt-4 flex items-center gap-2 cursor-pointer">
						<FaRegImage className="text-blue-500" />
						<span
							onClick={() => {
								setShowModal(true);
								pauseScroll.current = true;
							}}
						>
							Immagine allerta
						</span>
					</p>
				)}
			</div>

			{/* Modale */}
			{showModal && (
				<AlertImageModal
					mode={mode}
					alertData={alert}
					onClose={() => {
						pauseScroll.current = false;
						setShowModal(false);
					}}
				/>
			)}
		</>
	);
}

export default AlertCard;
